export class StringHelper {
    static uriToSlug(uri: string): string {
        return uri
            .toLowerCase()
            .replace(/^\/|\/$/g, '')
            .replace('/', '-');
    }
}
